import RegressionModel from "@/types/RegressionModel";

type Props = {
  model: RegressionModel;
  className?: string;
};

export function RegressionModelDetails({ model, className }: Props) {
  switch (model) {
    case RegressionModel.Loess:
      return (
        <div className={className}>
          The <strong>locally weighted regression</strong> combines a moving average with polynomial
          regression to calculate a smooth curve through a scatterplot of data. The result is a
          market trend that reflects seasonality and market conditions changes over time.
        </div>
      );
    case RegressionModel.Linear:
      return (
        <div className={className}>
          The <strong>linear</strong> trend calculates growth between the beginning and end of the
          data set. A linear trend will not account for any seasonal or non-linear market trends,
          and therefore should only be used when very limited trend data is available, or in very
          stable/non-variable market conditions.
        </div>
      );
  }
}
